import React from 'react'
import Loader from '../../../app/custom/loaders/Loader'
import SchedulerNavigateNewVersion from './scheduleNavigate/SchedulerNavigateNewVersion'
import ScheduleFiltersDesktop from './filters/ScheduleFiltersDesktop'
import ScheduleFiltersListDesktop from './filters/ScheduleFiltersListDesktop'
import ViewingsList from './viewingsList/ViewingsList'
import OffersList from './offersList/OffersList'
import ReferralsList from './referalsList/ReferralsList'
import AdvertiseList from './advertisesList/AdvertiseList'
import ScheduleAdvertiseAttention from './attenton/ScheduleAdvertiseAttention'
import ScheduleOfferAttention from './attenton/ScheduleOfferAttention'
import ScheduleViewingAttention from './attenton/ScheduleViewingAttention'
import { advertiseAttention, offersAttention, placeholders, viewingsAttention } from '../../../urls'
import { ScheduleAccordion } from './ScheduleAccordion'
import { type ScheduleViewModel } from './hooks/useScheduleVM'
import PortalRequestCard from './portalRequests/PortalRequestCard'
import AgentActivityList from './agentActivity/AgentActivityList'

import './ScheduleDesktopView.scss'

interface ScheduleDesktopViewProps {
    vm: ScheduleViewModel
}

export function ScheduleDesktopView({ vm }: ScheduleDesktopViewProps): JSX.Element {
    const {
        loading,
        filterNavigate,
        isThereNotices,
        expanded,
        setExpanded,
        advertisesNotifies,
        offersNotifies,
        viewingsNotifies,
        filteredAdvertises,
        filteredOffers,
        filteredViewings,
        allAttention,
        portalViewingRequests,
        portalOfferRequests,
        portalAllRequests,
        agentActivityCards,
        showPopupScheduleFilters,
        scheduleFiltersApply,
        setScheduleFiltersApply,
        openAgentActivityItem,
        openFiltersPopup,
        mainButtonOpen,
        isDesktop
    } = vm

    if (loading) return <Loader />

    return (
        <div className="schedule-desktop">
            <div className="schedule-desktop__shell">
                <div className="schedule-desktop__header">
                    <div className="schedule-desktop__title-block">
                        <p className="schedule-desktop__eyebrow">Tasks overview</p>
                        <h1 className="schedule-desktop__title">Schedule</h1>

                        <div className="schedule-desktop__stats">
                            <SchedulerNavigateNewVersion
                                countView={filteredViewings.length}
                                countOffers={filteredOffers.length}
                                countAdvertises={filteredAdvertises.length}
                                broadcastMessagesCount={0}
                                viewingsNotifies={viewingsNotifies?.length}
                                offersNotifies={offersNotifies?.length}
                                advertisesNotifies={advertisesNotifies?.length}
                                portalRequestsCount={portalAllRequests.length}
                                portalRequestsNotifies={portalAllRequests.length}
                                agentActivityCount={agentActivityCards.length}
                                allAttention={allAttention.length}
                                isDesktop={isDesktop}
                            />



                            {/* {stats.map((item) => (
                                <div key={item.label} className="schedule-desktop__stat">
                                    <span className="schedule-desktop__stat-label">{item.label}</span>
                                    <span className="schedule-desktop__stat-value">{item.value}</span>
                                </div>
                            ))} */}
                        </div>
                    </div>
                    <div className="schedule-desktop__actions">
                        <button className="schedule-desktop__filter btn btn-bso mt-2" onClick={openFiltersPopup}>
                            <i className="ki-duotone ki-setting-3 fs-2"></i>
                            <span>Filters</span>
                        </button>
                    </div>
                </div>



                <div className="schedule-desktop__content card shadow-sm">
                    {
                        filterNavigate === 'attention'
                            ? (
                                isThereNotices
                                    ? (
                                        <div className="schedule-desktop__accordions">
                                            <ScheduleAccordion key={'Advertises'} group={'Advertises'} expanded={expanded}
                                                setExpanded={setExpanded} countLable={advertisesNotifies.length} imgCover={advertiseAttention} >
                                                {advertisesNotifies
                                                    .map((adv: any) => (
                                                        <div
                                                            key={adv.id}
                                                            className="card shadow-sm mb-4 position-relative"
                                                        >
                                                            <ScheduleAdvertiseAttention
                                                                key={"list-attention-advertises"}
                                                                advertise={adv}
                                                            />
                                                        </div>
                                                    ))}
                                            </ScheduleAccordion>

                                            <ScheduleAccordion key={'Offers'} imgCover={offersAttention} group={'Offers'} expanded={expanded} setExpanded={setExpanded} countLable={offersNotifies.length}>
                                                {offersNotifies
                                                    .map((offer: any) => (
                                                        <div
                                                            key={offer.id}
                                                            className="card shadow-sm mb-3 position-relative"
                                                        >
                                                            <ScheduleOfferAttention key={"list-attention-offers"} offer={offer} />
                                                        </div>
                                                    ))}
                                            </ScheduleAccordion>

                                            <ScheduleAccordion key={'Viewings'} imgCover={viewingsAttention} group={'Viewings'} expanded={expanded} setExpanded={setExpanded} countLable={viewingsNotifies.length}>
                                                {viewingsNotifies.length > 0 && viewingsNotifies.map((view: any) => (
                                                    <div key={view.id} className="card shadow-sm mb-3 mt-1 position-relative">
                                                        <ScheduleViewingAttention key={"list-attention-viewings"} view={view} />
                                                    </div>
                                                ))}
                                            </ScheduleAccordion>
                                        </div>
                                    )
                                    : (
                                        <div className={'schedule-desktop__empty'} >
                                            <img
                                                className="schedule-desktop__empty-image"
                                                src={placeholders.Notices}
                                                alt={'liable_picture'}
                                            />
                                            <span className="schedule-desktop__empty-label">
                                                You don't have any new notifications
                                            </span>
                                        </div>
                                    )
                            )
                            : null
                    }

                    {
                        filterNavigate === 'viewings'
                            ? (
                                <>
                                    <ViewingsList viewings={filteredViewings} key={"list-viewings"} />
                                </>
                            )
                            : null
                    }
                    {
                        filterNavigate === 'offers'
                            ? (
                                <>
                                    <OffersList offers={filteredOffers} key={"list-offers"} />
                                </>
                            )
                            : null
                    }
                    {
                        filterNavigate === 'agent_activity'
                            ? (
                                <AgentActivityList cards={agentActivityCards} onTaskClick={openAgentActivityItem} />
                            )
                            : null
                    }
                    {
                        filterNavigate === 'portal_requests'
                            ? (
                                portalAllRequests.length > 0
                                    ? <>
                                        <ScheduleAccordion key={'PortalViewingRequests'} group={'Viewing Requests'} expanded={expanded} setExpanded={setExpanded} countLable={portalViewingRequests.length} imgCover={viewingsAttention}>
                                            {portalViewingRequests.map((request) => (
                                                <PortalRequestCard key={`portal-viewing-${request.orderId}`} request={request} />
                                            ))}
                                        </ScheduleAccordion>
                                        <ScheduleAccordion key={'PortalOfferRequests'} group={'Offer Requests'} expanded={expanded} setExpanded={setExpanded} countLable={portalOfferRequests.length} imgCover={offersAttention}>
                                            {portalOfferRequests.map((request) => (
                                                <PortalRequestCard key={`portal-offer-${request.orderId}`} request={request} />
                                            ))}
                                        </ScheduleAccordion>
                                    </>
                                    : (
                                        <div className={'schedule-desktop__empty'} >
                                            <img
                                                className="schedule-desktop__empty-image"
                                                src={placeholders.Notices}
                                                alt={'liable_picture'}
                                            />
                                            <span className="schedule-desktop__empty-label">
                                                No portal requests yet
                                            </span>
                                        </div>
                                    )
                            )
                            : null
                    }
                    {
                        filterNavigate === 'referrals'
                            ? (
                                <ReferralsList key={"list-referrals"} />
                            )
                            : null
                    }
                    {
                        filterNavigate === 'adverts'
                            ? (
                                <AdvertiseList advertises={filteredAdvertises} key={"list-adverts"} />
                            )
                            : null
                    }
                </div>
                {
                    showPopupScheduleFilters
                        ? <ScheduleFiltersDesktop title='ScheduleFilters'>
                            <ScheduleFiltersListDesktop scheduleFiltersApply={scheduleFiltersApply} setScheduleFiltersApply={setScheduleFiltersApply} filteredViewings={filteredViewings} filteredOffers={filteredOffers} filteredAdvertises={filteredAdvertises} />
                        </ScheduleFiltersDesktop >
                        : null}
            </div>
            {
                mainButtonOpen
                    ? <div className="schedule-desktop__main-button-space" />
                    : null
            }
        </div>
    )
}
